import { GridSize } from '@atoms/GridSlider/GridSlider';
import ListingTypeEnum from '@models/enums/ListingTypeEnum';
import SiteEnum from '@models/enums/SiteEnum';
import { CardType } from '@models/IListingWrapper';
import { getGridConfig } from '../grid';

interface Props {
  readonly cardType: CardType;
  readonly site: SiteEnum;
  readonly gridSize: GridSize;
  readonly type: ListingTypeEnum;
}

export const setCardPositionInGrid = ({
  cardType,
  gridSize,
  site,
  type,
}: Props) => {
  const gridConfig = getGridConfig(gridSize, type);

  if (!gridConfig) {
    return '';
  }

  const {
    cardSize,
    hotspotPosition,
    colourInspirationPosition,
    productInspirationPosition,
  } = gridConfig;

  const isColourInsporation =
    type !== ListingTypeEnum.Product || site === SiteEnum.B2B;

  const byType: Record<CardType, string> = {
    product: cardSize,
    colour: cardSize,
    inspiration: isColourInsporation
      ? colourInspirationPosition
      : productInspirationPosition,
    hotspot: hotspotPosition,
  };

  return byType[cardType];
};
